import { ARM_ROWS } from "./arms.js";
import { count, spanFull } from "./clock.js";
/** The arms reading each measurement, filtered from the table rather than listed twice. */
const ARMS_WATCHING = new Map();
for (const arm of ARM_ROWS) {
    if (!arm.watches)
        continue;
    ARMS_WATCHING.set(arm.watches, [...(ARMS_WATCHING.get(arm.watches) ?? []), arm.capability]);
}
const SPECS = [
    {
        id: "sitting",
        behaviour: "movement",
        label: "Sitting",
        timing: "today",
        read: (r) => {
            const sat = r.body.idleMinutes;
            if (sat == null)
                return null;
            return {
                // Only claim a usual that is theirs.
                reading: r.ownBars.idleThreshold
                    ? `${spanFull(sat)} sitting, against your usual ${spanFull(r.idleThreshold)}`
                    : `${spanFull(sat)} sitting`,
                move: "Feel like getting on your feet?",
            };
        },
    },
    {
        id: "steps",
        behaviour: "movement",
        label: "Steps",
        timing: "today",
        read: (r) => {
            const steps = r.body.stepsToday;
            if (steps == null)
                return null;
            return {
                reading: r.ownBars.middayFloor
                    ? `${count(steps)} today, against the ${count(r.middayFloor)} you usually have by now`
                    : `${count(steps)} today`,
                move: steps < r.middayFloor ? "Feel like taking a quick walk?" : "A little more movement?",
            };
        },
    },
    {
        id: "load",
        behaviour: "stress",
        label: "Meeting load",
        timing: "today",
        read: (r) => {
            const booked = r.forecast.meetingMinutes;
            if (booked <= 0)
                return null;
            return {
                reading: `${spanFull(Math.round(booked))} booked, against the ${spanFull(Math.round(r.heavyThreshold))} that reads as heavy for you`,
                move: r.heavy
                    ? "Want to make a little room in your day?"
                    : "Your schedule looks manageable",
            };
        },
    },
    {
        id: "overnight",
        behaviour: "sleep",
        label: "Overnight readings",
        timing: "tonight",
        read: (r) => {
            const off = r.body.readingsOffUsual ?? [];
            if (off.length === 0)
                return null;
            return {
                reading: `${off.length === 1 ? "One reading is" : `${off.length} readings are`} off your usual band`,
                move: "A little more time to wind down could help you sleep",
            };
        },
    },
    {
        id: "outdoors",
        behaviour: "movement",
        label: "Time outdoors",
        timing: "today",
        read: (r) => {
            const sunset = r.body.weather?.sunsetMinutes;
            if (sunset == null || r.body.walkedToday !== false)
                return null;
            const left = sunset - r.nowMinutes;
            if (left <= 0)
                return null;
            return {
                reading: `No walk outdoors yet, ${spanFull(left)} of daylight left`,
                move: "There's still time to get outside before sunset",
            };
        },
    },
];
/** How much a reading had to earn its place, strongest first. */
const WATCH_RANK = {
    overnight: 0,
    sitting: 1,
    outdoors: 2,
    steps: 3,
    load: 4,
};
/** The measurements Heartbeat can act on, strongest reading first. */
export function heartbeatWatching(read, limit = 2) {
    return SPECS.flatMap(({ read: readRow, ...row }) => {
        const now = readRow(read);
        return now ? [{ ...row, ...now, arms: ARMS_WATCHING.get(row.id) ?? [] }] : [];
    })
        .sort((a, b) => WATCH_RANK[a.id] - WATCH_RANK[b.id])
        .slice(0, limit);
}
//# sourceMappingURL=watchlist.js.map